/* Product page scroll reveals (settings.millian_scroll_anim): sections of
   the product info column fade-rise-focus in as they enter the viewport.
   One-shot per element; consecutive reveals within a beat stagger so a
   whole screenful cascades instead of popping at once. The initial hidden
   state only applies under html.millian-anim (added inline before paint),
   so with JS unavailable nothing is ever invisible. */
(function () {
  if (window.__millianReveal) return;
  window.__millianReveal = true;

  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    document.documentElement.classList.remove('millian-anim');
    return;
  }

  var SELECTORS = [
    '.product__info-container > *',
    // Inside the Details/Returns tabs: each ported card reveals on its own.
    '.custom-tab-panel .scent-section > *',
  ].join(', ');

  var chain = 0;
  var lastRevealAt = 0;

  function setup() {
    var els = document.querySelectorAll(SELECTORS);
    if (!els.length) {
      document.documentElement.classList.remove('millian-anim');
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var now = performance.now();
          // Reveals landing in the same beat cascade; a fresh scroll resets.
          chain = now - lastRevealAt < 180 ? Math.min(chain + 1, 5) : 0;
          lastRevealAt = now;
          entry.target.style.setProperty('--millian-reveal-delay', chain * 75 + 'ms');
          entry.target.classList.add('is-revealed');
          observer.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.05 }
    );

    els.forEach(function (el) {
      // Skip anything Dawn already scroll-animates and bare script/style tags.
      if (el.classList.contains('scroll-trigger')) return;
      if (el.tagName === 'SCRIPT' || el.tagName === 'STYLE' || el.tagName === 'LINK') return;
      el.classList.add('millian-reveal');
      observer.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup);
  } else {
    setup();
  }
})();
